export default __webpack_public_path__ + "static/media/icon-obnizona zawartosc cukru.aa6f26f7.png";